import React, { useEffect, useMemo } from "react";
import { useThree } from "react-three-fiber";
import anime from "animejs";

import { State } from "../core";
import { Vector3 } from "three";
import { INDICATOR_SHRINK_DURATION } from "../constants";

interface SceneProps {
  state: State;
}
export const Scene: React.FC<SceneProps> = React.memo(({ state, children }) => {
  let { camera } = useThree();
  let cameraTarget = useMemo(() => new Vector3(0, 5, 5), []);

  let isEntry = state.state === "start";
  let isSending = state.state === "sending" || state.state === "sent";
  useEffect(() => {
    if (isSending) {
      let liftAnim = anime({
        targets: camera.position,
        z: 8,
        duration: INDICATOR_SHRINK_DURATION,
        easing: "easeInOutCubic",
        update: () => camera.lookAt(cameraTarget)
      });
      let zoomAnim = anime({
        targets: camera.position,
        y: 0,
        duration: 10000,
        delay: INDICATOR_SHRINK_DURATION,
        easing: "easeInOutCubic"
      });
      let targetAnim = anime({
        targets: cameraTarget,
        y: 10,
        duration: 10000,
        delay: INDICATOR_SHRINK_DURATION,
        easing: "easeInOutCubic",
        update: () => camera.lookAt(cameraTarget)
      });
      return () => {
        liftAnim.pause();
        zoomAnim.pause();
        targetAnim.pause();
      };
    } else {
      if (isEntry) {
        camera.position.z = 10;
        camera.position.y = -5;
        camera.lookAt(cameraTarget);
      }
      let posAnim = anime({
        targets: camera.position,
        z: 5,
        y: -4,
        duration: 1000,
        easing: isEntry ? "easeOutCubic" : "easeInOutCubic"
      });
      let targetAnim = anime({
        targets: cameraTarget,
        z: 0,
        y: 5,
        duration: 1000,
        easing: isEntry ? "easeOutCubic" : "easeInOutCubic",
        update: () => camera.lookAt(cameraTarget)
      });
      return () => {
        posAnim.pause();
        targetAnim.pause();
      };
    }
  }, [camera, cameraTarget, isEntry, isSending]);

  return <>{children}</>;
});
